// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/arrow-up.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'arrow-up',
  version: 'solid',
  paths: [
    {
      d: 'M12 20.4a.9.9 0 0 1-.9-.9V6.7344L6.348 11.724a.9.9 0 0 1-1.296-1.248l6.3-6.6a.9.9 0 0 1 1.296 0l6.3 6.6a.9.9 0 1 1-1.296 1.248L12.9 6.7344V19.5a.9.9 0 0 1-.9.9',
      fillRule: 'evenodd',
    },
  ],
}
